const initialState = {
  token: "",
  config: {},
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        token: action.payload.accessToken,
        config: action.payload.config,
      };
    default:
      return state;
  }
};

export default authReducer;
